// Takes content retrieved from Seo data lookup DB
// and pushes content to data layer, interactions and segment
import { track } from 'mex_components/app/scripts/tracking/track';

$(function () {
  const seoFields = {
    url: 'none',
    subject: 'none',
    vt_type: 'none',
    location: 'none',
    page_type: 'none',
    segment: 'none',
  };

  $.each(seoFields, function (field) {
    const metaTag = $(`meta[property='${field}']`).first();
    let metaTagValue;

    if (metaTag) {
      metaTagValue = metaTag.attr('content');
    }

    if (metaTagValue && metaTagValue.toLowerCase() !== 'nan') {
      seoFields[field] = metaTagValue;
    }
  });

  const eventName = 'seoLookupEvent';
  const dataPayload = {
    event: 'seoLookupEvent',
    url: seoFields['url'],
    subject: seoFields['subject'],
    vt_type: seoFields['vt_type'],
    location: seoFields['location'],
    page_type: seoFields['page_type'],
    segment: seoFields['segment'],
  };

  if (window.newrelic) {
    if (!window.dataLayer) {
      window.newrelic.addPageAction('dataLayer_error', {
        category: 'dataLayer',
        label: 'dataLayer not found',
        value: dataPayload.segment,
      });
    } else {
      window.newrelic.addPageAction('dataLayer_success', {
        category: 'dataLayer',
        label: 'dataLayer found, pushing values',
        value: dataPayload.segment,
      });
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataPayload);

  track(eventName, { 
    category: 'seo',
    label: eventName,
    value: dataPayload.segment,
    target: 'document'
  });
});
